import { fetchEnquiry } from "./api";
/*
    DOOR Actions
*/
import { getDefaultApiKey } from "./../selectors";

export * from "./door";

/*
    WINDOW Actions
*/

export * from "./window";

/*
    ADDITIONAL Actions
*/

export * from "./additional";

/*
    CONSERVATORY Actions
*/


export * from "./conservatory";

/*
    Enquiry Action
*/

export * from "./enquiry";

/*
    URL Resolver Action
*/

export * from "./urlResolver";

/*
    Item Selector Action
*/

export * from "./itemSelector"

/*
    OTHER
*/
export const updatePreviousSelection = selections => {
    return {
        type: "UPDATE_PREVIOUS_SELECTION",
        payload: selections
    };
};

export const deleteProduct = index => {
    return {
        type: "DELETE_PRODUCT",
        payload: { index }
    };
};

export const changeProductQuantity = (index, value) => {
    return {
        type: "CHANGE_QUANTITY_PRODUCT",
        payload: { index, value }
    };
};

export const loadCustomerGuid = (customerGuid, callback) => {
    customerGuid = getDefaultApiKey(customerGuid);

    return dispatch => {
        dispatch({
            type: "LOAD_TRADE_CUSTOMER",
            payload: fetchEnquiry(customerGuid, "/TradeCustomer", false)
                // if we fail finding the customer GUID, default to DGN
                .fail(() => {
                    setCustomerAsDGN(callback)(dispatch);
                })
        }).then(callback);
    };
};

export const setCustomerAsDGN = callback => {
    return dispatch => {
        dispatch({
            type: "LOAD_TRADE_CUSTOMER",
            payload: fetchEnquiry(getDefaultApiKey(null, true), "/TradeCustomer")
        }).then(callback);
    };
};

export const addPreviousPreviews = (filters, rankList, callback) => {
    return (dispatch, getState) => {
        // get the filtered list of previews

        let previews = getState().PreviewImages.filter(p => {
            for (let filter in filters) {
                if (p[filter] !== filters[filter]) return false;
            }
            return true;
        });

        let preview = previews[0];

        if (preview) {
            // for each rank, grab the url and dispatch
            for (let i = 0; i < rankList.length; i++) {
                let rank = rankList[i];
                let src = preview["url" + rank];
                dispatch({
                    type: "ADD_PREVIEW",
                    payload: { rank, src }
                });
            }
        }

        if (callback) callback();
    };
};

export const emptyPreviewImages = () => ({ type: "EMPTY_IMAGE_PREVIEWS" });
export const emptyPreviousPreviews = () => ({ type: "EMPTY_PREVIEWS" });



// WEBPACK FOOTER //
// ./src/actions/index.js